"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function SegmentCheckbox(_ref) {
  var _persona$acf, _persona$acf2;

  var persona = _ref.persona,
      selectedPersonas = _ref.selectedPersonas,
      removeSelectedPersona = _ref.removeSelectedPersona,
      addSelectedPersona = _ref.addSelectedPersona;

  var handlePersonaClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(persona) {
      var selected;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selected = selectedPersonas.find(function (value) {
                return value.id === persona.id;
              });

              if (!selected) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return removeSelectedPersona(persona);

            case 4:
              _context.next = 8;
              break;

            case 6:
              _context.next = 8;
              return addSelectedPersona(persona);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePersonaClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Checkbox, {
    style: {
      background: persona === null || persona === void 0 ? void 0 : (_persona$acf = persona.acf) === null || _persona$acf === void 0 ? void 0 : _persona$acf.color,
      color: persona === null || persona === void 0 ? void 0 : (_persona$acf2 = persona.acf) === null || _persona$acf2 === void 0 ? void 0 : _persona$acf2.color
    },
    onClick: function onClick() {
      handlePersonaClick({
        id: parseInt(persona.postName),
        name: persona.acf.title
      });
    },
    checked: selectedPersonas.find(function (value) {
      return parseInt(value.id) === parseInt(persona.postName);
    }) ? true : false // className="persona-list-community__persona-checkbox"
    ,
    className: "community-tile--checkbox",
    "data-canonical-name": persona.postName + ' ' + persona.acf.title,
    label: /*#__PURE__*/_react["default"].createElement("label", {
      className: "community-tile--checkbox-label"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "community-tile-menu__number"
    }, persona.acf.personacommunityNumber), ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: "community-tile-menu__name"
    }, persona.acf.title))
  });
}

var _default = SegmentCheckbox;
exports["default"] = _default;